<template>
  <div class="grey lighten-4 px-3">
    <v-row>
      <v-col cols="7" class="pt-0">
        <v-autocomplete
          v-model="contact"
          :items="contactPersonListNew"
          chips
          item-text="name"
          item-value="name"
          :filter="customFilter"
          color="blue-grey lighten-2"
          :error-messages="formValidator.getError('contact')"
          label="Client Contact Person"
        >
          <template v-slot:selection="data">
            <v-chip
              v-bind="data.attrs"
              :input-value="data.selected"
              close
              @click="data.select"
              @click:close="contact = {}"
            >
              <v-avatar left>
                <v-img
                  :src="
                    data.item.image ||
                      require(`@/static/images/info/user-default.png`)
                  "
                ></v-img>
              </v-avatar>
              <span class="caption">{{ data.item.name }}</span>
            </v-chip>
          </template>
          <template v-slot:item="data">
            <template v-if="typeof data.item !== 'object'">
              <v-list-item-content v-text="data.item"></v-list-item-content>
            </template>
            <template v-else>
              <v-list-item-avatar>
                <img
                  :src="
                    data.item.image ||
                      require(`@/static/images/info/user-default.png`)
                  "
                />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  class="body-2"
                  v-html="data.item.name"
                ></v-list-item-title>
                <v-list-item-subtitle
                  class="caption"
                  v-html="
                    data.item.designation && data.item.designation.name
                      ? data.item.designation.name
                      : ''
                  "
                ></v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="5" class="text-right pr-5">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-hover>
              <v-icon
                v-on="on"
                color="blue lighten-4"
                class="blue--text text--darken-2 mt-3"
                @click="update()"
                v-text="$getIcon('mdiSquareEditOutline')"
              ></v-icon>
            </v-hover>
          </template>
          Update Contact
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-hover>
              <v-btn
                v-on="on"
                depressed
                tile
                icon
                @click="
                  (showContactPersonForm = true), (contactPersonData = null)
                "
                class="blue lighten-4 ml-3 mt-3"
              >
                <v-icon
                  color="blue darken-2"
                  v-text="$getIcon('mdiPlus')"
                ></v-icon>
              </v-btn>
            </v-hover>
          </template>
          Add New Contact
        </v-tooltip>
      </v-col>
    </v-row>

    <v-bottom-sheet v-model="showContactPersonForm" persistent scrollable>
      <v-card tile>
        <vue-card-title
          :title="contactPersonFormTitle"
          :subtitle="'Fill up the following form to action on client data.'"
          :icon="$getIcon('mdiFileDocumentEdit')"
          closable
          @close="(showContactPersonForm = false), $emit('refreshContactList')"
        >
        </vue-card-title>
        <v-divider></v-divider>
        <v-card-text class="form-scroll scrollbar">
          <contact-person-form
            add-new
            v-if="showContactPersonForm"
            :action-data="contactPersonData ? contactPersonData : undefined"
            :client="client"
            @contactPersonFormResponse="
              formSuccess($event), $emit('refreshContactList')
            "
          >
          </contact-person-form>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>
<script>
import ContactPersonForm from "@/components/crm/client/forms/ContactPersonForm";
export default {
  data() {
    return {
      contact: "",
      showContactPersonForm: false,
      contactPersonData: {},
      contactPersonListNew: [],
      newcontact: {}
    };
  },
  components: { ContactPersonForm },
  props: {
    contactPersonList: {
      type: Array,
      required: true
    },
    formValidator: {
      type: Object,
      required: true
    },
    client: {
      type: Object,
      required: true
    },
    contactPerson: {
      type: Object,
      required: true
    }
  },
  computed: {
    contactPersonFormTitle() {
      let action = this.contactPersonData ? "Update" : "Create";
      return `${action} Contact Person`;
    }
  },
  watch: {
    contactPerson: {
      handler(val) {
        if (val) {
          this.contact = val;
          this.contactPersonData = val;
          this.$emit("contactPersonUpdate", val);
        }
      },
      immediate: true
    },
    contact: {
      handler(val) {
        if (val) {
          if (typeof val === "string") {
            this.newcontact = this.contactPersonListNew.find(
              each => each.name === val
            );
            this.$emit("contactPersonUpdate", this.newcontact);
          } else {
            this.$emit("contactPersonUpdate", val);
          }
        }
      }
    },
    contactPersonList: {
      handler(val) {
        if (val) {
          this.contactPersonListNew = val;
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.getContactPersons();
  },
  methods: {
    getContactPersons() {
      this.$axios
        .get(
          `/api/v1/crm/client-contact-person/choices/?client__slug=${this.client.slug}`
        )
        .then(({ data }) => {
          this.contactPersonListNew = data;
        });
    },
    update() {
      if (!Object.keys(this.contact).length) {
        this.$store.dispatch("shell/showSnackbar", {
          text: `Please select a contact person`,
          color: "red"
        });
      } else {
        this.showContactPersonForm = true;
        this.contactPersonData = this.contact;
      }
    },
    formSuccess(response) {
      this.contact = response;
      this.showContactPersonForm = false;
      this.getContactPersons();
    },
    customFilter(item, queryText) {
      const textOne = item.name.toLowerCase();
      const searchText = queryText.toLowerCase();

      return textOne.indexOf(searchText) > -1;
    }
  }
};
</script>
